import { render, staticRenderFns } from "./BrandSettings.vue?vue&type=template&id=7211e631&scoped=true&"
import script from "./BrandSettings.vue?vue&type=script&lang=js&"
export * from "./BrandSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrandSettings.vue?vue&type=style&index=0&id=7211e631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7211e631",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7211e631')) {
      api.createRecord('7211e631', component.options)
    } else {
      api.reload('7211e631', component.options)
    }
    module.hot.accept("./BrandSettings.vue?vue&type=template&id=7211e631&scoped=true&", function () {
      api.rerender('7211e631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/BrandSettings.vue"
export default component.exports